import { createAction } from 'redux-actions'

export const setCurrentUser = createAction('CURRENT_USER/SET_CURRENT_USER')
export const setAccountLogo = createAction('CURRENT_USER/SET_ACCOUNT_LOGO')
